/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { GradeOrigin } from './GradeOrigin';
import { User } from './User';
const GradeHistoryParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['changedAt', parsers.moment, 'changed_at'],
    ['isRubric', /* #__PURE__ */ parsers.maybeNull(codecBoolean), 'is_rubric'],
    ['grade', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
    ['passedBack', /* #__PURE__ */ parsers.maybeNull(codecBoolean), 'passed_back'],
    ['origin', GradeOrigin],
    ['user', /* #__PURE__ */ parsers.maybeNull(User)],
]));
export class GradeHistory extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GradeHistoryParser.decode(input).map(res => new GradeHistory(res));
    }
    static unsafeDecode(input) {
        return GradeHistory.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GradeHistoryParser.encode(data);
    }
    static schema() {
        return GradeHistoryParser.schema();
    }
}
